import { render, staticRenderFns } from "./Interprefy.vue?vue&type=template&id=28cbd875&lang=pug&"
import script from "./Interprefy.vue?vue&type=script&lang=ts&"
export * from "./Interprefy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports